import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { Button, Flex, Heading, Spacer } from '@chakra-ui/react'

import { MyOfferDisplayLevel } from '@/features/tableProfiles/constants/tableProfile.constant'
import { showCreateOfferModal } from '@/stores/offers/offersSlice'
import { camelToWords } from '@/utils/stringHelper'
import { OfferStage } from '../../constants'
import { MENU_SUB_GROUP_LABELS } from '@/features/systemVariables/constants'
import useOfferList from '../../hooks/useOfferList'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import { createExcelBlob } from '@/utils/fileHelper'
import { saveAs } from 'file-saver'

const OfferListHeader = ({
  offerStage,
  offerType,
  dataCount = 0,
  allOfferData,
  isEQuotation = false,
  menuSubGroup,
  filters,
}) => {
  const dispatch = useDispatch()
  const { useFetchMyOffers } = useOfferList()
  const isMenuSubGroupList = Boolean(menuSubGroup)

  const { refetch } = useFetchMyOffers(
    {
      page: 1,
      pageSize: 0,
      filters: {
        ...filters,
      },
    },
    MyOfferDisplayLevel.OFFER,
    {
      enabled: false,
      staleTime: Infinity,
    }
  )
  const handleCreate = useCallback(() => {
    dispatch(
      showCreateOfferModal({
        offerType: offerType,
      })
    )
  }, [dispatch, offerType])

  const handleDownload = useCallback(async () => {
    try {
      dispatch(showLoadingOverlay())
      const { data: fetchResult } = await refetch()

      console.log(fetchResult)

      if (!fetchResult || !Array.isArray(fetchResult.data)) {
        throw new Error('Failed to fetch offer data for download.')
      }
      const allOfferData = fetchResult.data

      const excelBlob = createExcelBlob(allOfferData)
      saveAs(excelBlob, 'offers.xlsx')
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }, [refetch, dispatch])

  return (
    <Flex p={5} borderBottom="1px solid #d8dbe0">
      <Heading>
        {offerStage === OfferStage.QUOTATION ? 'Offer ' : 'Booking '}
        {isMenuSubGroupList
          ? `(${MENU_SUB_GROUP_LABELS[menuSubGroup] || menuSubGroup})`
          : isEQuotation
            ? `(eQuotation)`
            : camelToWords(offerType)}
        ({dataCount})
      </Heading>

      <Spacer />

      <Flex gap={1} alignItems={'center'}>
        <Button colorScheme={'green'} onClick={handleDownload}>
          Download
        </Button>

        {offerStage === 'quotation' && !isEQuotation && !isMenuSubGroupList && (
          <Button colorScheme="blue" onClick={handleCreate}>
            Create Offer
          </Button>
        )}
      </Flex>
    </Flex>
  )
}

export default OfferListHeader
